// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__Kx9jV","links":"footer_links__aYjDs","link":"footer_link__1nqhZ","copyRight":"footer_copyRight__nWS-K"};